//
// removeNullArrayEntries
//

const removeNullArrayEntries = (array, removeUndefined = false) => {
  let index = array.length - 1;

  while (index >= 0) {
    if ((array[index] === null)
    || ((removeUndefined) && (array[index] === undefined))) {
      array.splice(index, 1);
    } else {
      index -= 1;
    }
  }
  return array;
  // return array.filter((item) =>
  // ((item !== null) && ((!removeUndefined) || (item !== undefined))));
};

export default removeNullArrayEntries;
